import dayjs from "dayjs"
import { Link } from "react-router-dom"

export default function MemberDetailSection({ data }) {
    return (
        <div className="bg-white border rounded-lg shadow p-6 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="col-span-1 md:col-span-1">
                    <h2 className="text-xl font-semibold mb-4">Detail Data Anggota</h2>
                    <div className="space-y-2">
                        <div className="flex justify-between py-2 border-b">
                            <span className="text-gray-600">Nomor Induk Kependudukan</span>
                            <span className="font-medium">{data?.no_id || '-'}</span>
                        </div>
                        <div className="flex justify-between py-2 border-b">
                            <span className="text-gray-600">Kode Anggota</span>
                            <span className="font-medium">{ data?.member_id_number || '-' }</span>
                        </div>
                        <div className="flex justify-between py-2 border-b">
                            <span className="text-gray-600">Nama Lengkap Anggota</span>
                            <span className="font-medium">{ data?.full_name || '-' }</span>
                        </div>
                        <div className="flex justify-between py-2 border-b">
                            <span className="text-gray-600">Jenis Kelamin</span>
                            <span className="font-medium">{ data?.gender || '-' }</span>
                        </div>
                        <div className="flex justify-between py-2 border-b">
                            <span className="text-gray-600">Tanggal Lahir</span>
                            <span className="font-medium">{ dayjs(data?.birth_date).format('DD/MM/YYYY') || '-' }</span>
                        </div>
                        <div className="flex justify-between py-2 border-b">
                            <span className="text-gray-600">Nomor Telepon / HP</span>
                            <span className="font-medium">{ data?.phone_number || '-' }</span>
                        </div>
                        <div className="flex justify-between py-2 border-b">
                            <span className="text-gray-600">Alamat</span>
                            <span className="font-medium">{ data?.address || '-' }</span>
                        </div>
                    </div>
                </div>

                <div className="col-span-1 md:col-span-1">
                    <h2 className="text-xl font-semibold mb-4">Simpanan Pokok & Wajib</h2>
                    <div className="space-y-2">
                        <div className="flex justify-between py-2 border-b">
                            <span className="text-gray-600">Simpanan Pokok</span>
                            <span className="font-medium">Rp. 0</span>
                        </div>
                        <div className="flex justify-between py-2 border-b">
                            <span className="text-gray-600">Simpanan Wajib</span>
                            <span className="font-medium">Rp. 0</span>
                        </div>
                        <div className="flex justify-between py-2 border-b">
                            <span className="text-gray-600">Lunas Simpanan Wajib</span>
                            <span className="font-medium">Rp. 0</span>
                        </div>
                        <div className="flex justify-between py-2 border-b">
                            <span className="text-gray-600">Simpanan Sukarela</span>
                            <span className="font-medium">Rp. 0</span>
                        </div>
                        <div className="flex justify-between py-2 border-b">
                            <span className="text-gray-600">Terdaftar Sejak</span>
                            <span className="font-medium">{ dayjs(data?.join_date).format('DD/MM/YYYY') || '-' }</span>
                        </div>
                    </div>
                </div>

                <div className="col-span-1 md:col-span-1 flex flex-col items-center mt-[50px] gap-3">
                    <a
                        href={`${import.meta.env.VITE_API_BASE_URL}/storage/${data?.id_file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-blue-500 hover:bg-blue-600 text-center text-white font-bold py-2 px-4 rounded w-full">
                        Lihat Foto KTP
                    </a>
                    <Link to={`/admin/members/${data?.id}`} className="bg-blue-500 text-center hover:bg-blue-600 text-white font-bold py-2 px-4 rounded w-full">
                        Detail Data Anggota
                    </Link>
                </div>
            </div>
        </div>
    )
}